import { render, staticRenderFns } from "./EditorHeaderPrivateModeSetting.vue?vue&type=template&id=18694f54&scoped=true&"
import script from "./EditorHeaderPrivateModeSetting.vue?vue&type=script&lang=js&"
export * from "./EditorHeaderPrivateModeSetting.vue?vue&type=script&lang=js&"
import style0 from "./EditorHeaderPrivateModeSetting.vue?vue&type=style&index=0&id=18694f54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18694f54",
  null
  
)

export default component.exports